var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quick-tips',{attrs:{"tips":_vm.tips}})}
var staticRenderFns = []

export { render, staticRenderFns }